import useTableColumns from '@components/ListV2/hooks/useTableColumns';
import { MouseEvent, useState } from 'react';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../../modules/translation/TranslationContext';
import { ColumnsVisibilityTestIds } from '../../../../utils/testIds/columnsVisibility.testIds';
import ToolbarPopover from '../ToolbarPopover/ToolbarPopover';
import ColumnsVisibility from './ColumnsVisibility';
import { ColumnVisibilityItem, ViewSettingsControlProps } from './columnsVisibility.types';
import ColumnsVisibilityTrigger from './components/ColumnsVisibilityTrigger/ColumnsVisibilityTrigger';

const ViewSettingsControl = <T,>({
  columns,
  list,
  tabsSlot,
  configs,
  testId,
  icon,
}: ViewSettingsControlProps<T>) => {
  const { translate } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const visibleColumns = columns.filter((column) => !column.hide);

  const { columnsToShow, canRestoreToDefaultColumns } = useTableColumns(visibleColumns, list);

  const mappedColumns: ColumnVisibilityItem[] = visibleColumns.map((column) => ({
    key: column.name,
    name: translate(column.title as LangEnum),
    isVisible: columnsToShow.some((visible) => visible.name === column.name),
    canHide: column.canHide,
    showByDefault: column.showByDefault,
  }));

  const handleOpen = (event: MouseEvent<HTMLButtonElement>) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <ColumnsVisibilityTrigger
        onClick={handleOpen}
        testId={testId ?? ColumnsVisibilityTestIds.TRIGGER_BUTTON}
        icon={icon}
        isActive={!!anchorEl}
      />
      <ToolbarPopover
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handleClose}
        testId={ColumnsVisibilityTestIds.WRAPPER}
        paperSx={{ minWidth: 250, maxWidth: 400 }}
      >
        <ColumnsVisibility
          columns={mappedColumns}
          list={list}
          onClose={handleClose}
          canRestoreToDefaultColumns={canRestoreToDefaultColumns}
          tabsSlot={tabsSlot}
          configs={configs}
        />
      </ToolbarPopover>
    </>
  );
};

export default ViewSettingsControl;
